export default "__VITE_ASSET__BPAIWr$y__"